import axios from 'axios';
import { Fragment, useState } from 'react';
import Table from '../Table/Table';
import Header from '../Admin/Dashboard/Header';
import baseApi from '../api';
import moment from 'moment/moment';
import { Link } from 'react-router-dom';
import ConfirmModal from '../ConfirmModal/ConfirmModal';

const CaseStudyIndustry = () => {
  const [isLoading, setIsloading] = useState(false);
  const [itemTODelete, setItemToDelete] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleDelete = (id) => {
    setIsloading(true);
    let reqObj = {
      method: 'DELETE',
      url: `${baseApi}case-study/remove-case-study-industry/${id}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`
      }
    };

    axios(reqObj)
      .then((res) => {
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsloading(false);
      });
  };

  const columns = [
    {
      name: 'Case Study Industry',
      selector: (row) => `${row.case_study_industry}`,
      sortable: true,
      width: '330px',
      wrap: true
    },
    {
      name: 'Page title',
      selector: (row) => `${row.page_title}`,
      sortable: true,
      width: '330px',
      wrap: true
    },
    {
      name: 'Page Description',
      selector: (row) => `${row.page_description}`,
      sortable: true,
      width: '330px',
      wrap: true
    },
    {
      name: 'Date',
      selector: (row) => moment(row.createdAt).format('DD MMM YYYY'),
      sortable: true,
      width: '120px'
    },
    {
      name: 'Action',
      cell: (row) => (
        <Fragment>
          <div>
            <div>
              <a
                href="#0"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setItemToDelete(row._id);
                  openModal();
                }}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
              &nbsp;&nbsp;&nbsp;
              <Link to={'/edit-case-study-industry/' + row._id}>
                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
              </Link>
              &nbsp;&nbsp;&nbsp;
            </div>
          </div>
        </Fragment>
      )
    }
  ];
  const options = {
    title: 'Case Study Industry',
    type: 'CS Industry',
    columns: columns,
    apiUrl: `${baseApi}case-study/list-case-study-industry`,
    showAddBtn: true,
    AddBtnUrl: '/add-case-study-industry'
  };

  return (
    <Fragment>
      <Header title="Case Study Industry">
        <Table options={options} isLoading={isLoading} />
        <ConfirmModal isOpen={modalOpen} onClose={closeModal} type={'Case Study Industry'} content={'Are you sure you want to delete this industry?'} handleDelete={handleDelete} id={itemTODelete} />
      </Header>
    </Fragment>
  );
};

export default CaseStudyIndustry;
